<template>

  <div id="upload-container" >
    
    <div class="upload-container" >
    
            <h2>Add playlist</h2>
            <p>
              To use the application, you need to add a playlist. Please refer to How to use for guidance.
              <small class="example-link" @click="showExample = true">See example</small>

            </p>
            
            <form @submit.prevent="submitForm">
              <div class="input-container">
                <label for="androidId">Device ID</label>
                <input 
                  type="text" 
                  id="androidId" 
                  v-model="androidId" 
                  placeholder="Enter Device ID" 
                  required 
                />
              </div>
              <div class="input-container">
                <label for="m3u8Url">Playlist URL</label>
                <input 
                  type="url" 
                  id="m3u8Url" 
                  v-model="m3u8Url" 
                  placeholder="Enter M3U8 URL" 
                  required 
                />
              </div>
              <div class="input-container">
                <label for="name">Playlist Name</label>
                <input 
                  type="text" 
                  id="name" 
                  v-model="name" 
                  placeholder="Enter Playlist Name" 
                  required 
                />
              </div>
              <div class="input-container">
                <label for="epgUrl">EPG URL (optional)</label>
                <input 
                  type="url" 
                  id="epgUrl" 
                  v-model="epgUrl" 
                  placeholder="Enter EPG URL (optional)" 
                />
              </div>
              <div class="input-container">
                <label for="vodUrl">VOD URL (optional)</label>
                <input 
                  type="url" 
                  id="vodUrl" 
                  v-model="vodUrl" 
                  placeholder="Enter VOD URL (optional)" 
                />
              </div>
              <div class="input-container">
                <label for="vodUrl">Radio URL (optional)</label>
                <input 
                  type="url" 
                  id="radiourl" 
                  v-model="radioUrl" 
                  placeholder="Enter Radio URL (optional)" 
                />
              </div>
              <div class="input-container">
      <label for="securityCode">Security code (4 digits)</label> <span style="color:silver">Enter any custom code to be used as the playlist protection mechanism</span>
      <input
      type="text"
      id="securityCode"
      v-model="securityCode"
      placeholder="Enter 4-digit code"
      required
      maxlength="4"
      inputmode="numeric"
    />
    
    </div>
    
    <div id="recaptcha-upload"></div>

              <button type="submit" >Upload</button>
              <div v-if="isSubmitting">Processing...</div>
              <div v-if="statusMessage" class="status-message">{{ statusMessage }}</div>
            </form>
      
            <h2 style="padding-top:100px">Delete playlist</h2>
            <form @submit.prevent="deleteForm">
              <div class="input-container">
                <label for="deleteAndroidId">Device ID</label>
                <input 
                  type="text" 
                  id="deleteAndroidId" 
                  v-model="deleteAndroidId" 
                  placeholder="Enter Device ID" 
                  required 
                />
              </div>
              <div class="input-container">
                <label for="deleteName">Playlist Name</label>
                <input 
                  type="text" 
                  id="deleteName" 
                  v-model="deleteName" 
                  placeholder="Enter Playlist Name" 
                  required 
                />
              </div>
              <div class="input-container">
      <label for="securityCodeDelete">Security code (4 digits)</label><span style="color:silver">Enter the security code you set when adding the playlist.</span>
      <input
      type="text"
      id="securityCodeDelete"
      v-model="deleteSecurityCode" 
      placeholder="Enter 4-digit code"
      required
      maxlength="4"
      inputmode="numeric"
    />
    
    </div>
    
              <div
      class="g-recaptcha"
      id="recaptcha-delete"
      data-sitekey="6Lfx7SMsAAAAALgdKWlSs9-StRgUfvKXZ-FvEch_"
      data-callback="onCaptchaDeleteVerified">
    </div>
              <button type="submit" >Delete</button>
    
              <div v-if="isSubmitting">Processing...</div>
              <div v-if="statusMessageDelete" class="status-message">{{ statusMessageDelete }}</div>
            </form>
          </div>
         
        </div>
        <div id="line"></div>
        <div v-if="showExample" class="modal-backdrop" @click.self="showExample = false">
  <div class="modal-content">
    <img src="/ListExample.PNG" alt="Example Playlist" />
    
    <button class="close-btn" @click="showExample = false">CLOSE EXAMPLE</button>
  </div>
</div>


      </template>
      
    <script>
import axios from "axios";

export default {
  data() {
    return {
      androidId: "",
      m3u8Url: "",
      epgUrl: "",
      vodUrl: "",
      radioUrl: "",
      name: "",
      securityCode: "0000",

      deleteAndroidId: "",
      deleteName: "",
      deleteSecurityCode: "",

      // captcha
      widgetUpload: null,
      widgetDelete: null,
      recaptchaTokenUpload: "",
      recaptchaTokenDelete: "",
      isCaptchaUploadVerified: false,
      isCaptchaDeleteVerified: false,

      // status
      isSubmitting: false,
      statusMessage: "",
      statusMessageDelete: "",
    };
  },
  mounted() {
    const checkReady = () => {
      if (window.grecaptcha && window.grecaptcha.render) {
        this.initCaptchas();
      } else {
        setTimeout(checkReady, 500);
      }
    };
    checkReady();
  },
  beforeUnmount() {
    if (typeof window.grecaptcha?.reset === "function") {
      window.grecaptcha.reset(this.widgetUpload);
      window.grecaptcha.reset(this.widgetDelete);
    }
    this.widgetUpload = null;
    this.widgetDelete = null;
    this.isCaptchaUploadVerified = false;
    this.isCaptchaDeleteVerified = false;
    this.recaptchaTokenUpload = "";
    this.recaptchaTokenDelete = "";
  },
  methods: {
    initCaptchas() {
      if (!this.widgetUpload) {
    this.widgetUpload = window.grecaptcha.render("recaptcha-upload", {
  sitekey: "6Lfx7SMsAAAAALgdKWlSs9-StRgUfvKXZ-FvEch_",
  callback: (token) => {
    console.log("✅ Upload token:", token);
    this.isCaptchaUploadVerified = true;
    this.recaptchaTokenUpload = token; // <<< OVDE ti stiže token
  },
  "expired-callback": () => {
    this.isCaptchaUploadVerified = false;
    this.recaptchaTokenUpload = "";
  },
});

      }

      if (!this.widgetDelete) {
        this.widgetDelete = window.grecaptcha.render("recaptcha-delete", {
          sitekey: "6Lfx7SMsAAAAALgdKWlSs9-StRgUfvKXZ-FvEch_",
          callback: (token) => {
            this.isCaptchaDeleteVerified = true;
            this.recaptchaTokenDelete = token; // ✅ token se čuva
          },
          "expired-callback": () => {
            this.isCaptchaDeleteVerified = false;
            this.recaptchaTokenDelete = "";
          },
        });
      }
    },

    async submitForm() {
      this.isSubmitting = true;
      this.statusMessage = "";


      const payload = {
        deviceId: this.androidId,
        m3uUrl: this.m3u8Url,
        epg_url: this.epgUrl || null,
        name: this.name,
        vod_url: this.vodUrl || null,
        radio: this.radioUrl || null,
        recaptchaToken: this.recaptchaTokenUpload, // ✅ token ide na backend
        security_code: this.securityCode,
      };

      try {
        const response = await axios.post(
          "https://app.streamboxtv.live/api3002/upload-m3u",
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        this.statusMessage =
          response.data.message || "Playlist successfully uploaded!";
        console.log(response.data);

        // reset captcha
        window.grecaptcha.reset(this.widgetUpload);
        this.isCaptchaUploadVerified = false;
        this.recaptchaTokenUpload = "";
      } catch (error) {
        console.error("Error uploading M3U8 URL:", error.response || error.message);
        this.statusMessage =
          error.response?.data?.message || "Unknown error occurred during upload.";
      } finally {
        this.isSubmitting = false;
      }
    },

    async deleteForm() {
      if (!this.isCaptchaDeleteVerified || !this.recaptchaTokenDelete) {
        this.statusMessageDelete = "Please complete the CAPTCHA before deleting.";
        return;
      }

      this.isSubmitting = true;
      this.statusMessageDelete = "";

      const payload = {
        deviceId: this.deleteAndroidId,
        name: this.deleteName,
        recaptchaToken: this.recaptchaTokenDelete, // ✅ token ide na backend
        security_code: this.deleteSecurityCode,
      };

      try {
        const response = await axios.delete(
          "https://app.streamboxtv.live/api3002/api/delete-m3u-url",
          { params: payload }
        );

        this.statusMessageDelete =
          response.data.message || "Playlist deleted successfully!";
        console.log(response.data);

        // reset captcha
        window.grecaptcha.reset(this.widgetDelete);
        this.isCaptchaDeleteVerified = false;
        this.recaptchaTokenDelete = "";

        // reset input polja
        this.deleteAndroidId = "";
        this.deleteName = "";
        this.deleteSecurityCode = "";
      } catch (error) {
        console.error("Error deleting playlist:", error.response || error.message);
        this.statusMessageDelete =
          error.response?.data?.message || "Unknown error occurred during deletion.";
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

      
      <style scoped>
     .upload-container {
  background-color: rgba(0, 0, 0, 0.8); /* crni overlay preko slike */
  color: white;
  padding: 40px;
  border-radius: 15px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  border: 1px solid white;
  background-clip: padding-box;
  box-shadow: 0 0 40px rgba(0, 153, 255, 0.1);
  backdrop-filter: blur(40px);
}

#upload-container {
  background-image: url('@/assets/back2.jpg'); /* 🔁 ZAMENI sa stvarnom putanjom */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 100px 20px;
  min-height: 100vh;
  width: 100%;
}

h2 {
  font-weight: 600;
  color: #00ccff;
  margin-bottom: 20px;
}

p {
  color: #ccc;
  margin-bottom: 30px;
  font-size: 16px;
}

.input-container {
  margin-bottom: 20px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 6px;
  color: #fff;
  font-weight: bold;
}

input[type="url"],
input[type="text"] {
  width: 100%;
  padding: 12px;
border:none;
 outline:none;
  background-color: #1b1b1b;
  color: white;
  font-size: 14px;
}

button {
  width: 100%;
  padding: 12px;
  background: linear-gradient(90deg, #00ccff, #0044aa);
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-top: 40px;
  cursor: pointer;
  transition: 0.3s;
}


button:hover {
  filter: brightness(1.2);
}

button:disabled {
  background-color: #666;
  cursor: not-allowed;
}

.status-message {
  margin-top: 10px;
  font-size: 16px;
  color: #00ff00;
}

.status-message.error {
  color: #ff3333;
}

.g-recaptcha {
  margin-top: 20px;
  transform: scale(0.9);
  transform-origin: left;
}
#line {
    position: relative;
    top: 99.5%;
    left:0;
    width: 100vw;
    height: 2px;
    background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(0,99,255,1) 9%, rgba(23,46,147,1) 27%, rgba(222,0,127,1) 46%, rgba(0,72,202,1) 65%, rgba(171,0,78,1) 82%, rgba(9,9,121,1) 100%, rgba(0,76,196,1) 100%);
    background-size: 200% 100%;
    animation: move-gradient 10s linear infinite;
    box-shadow: 0px 5px 20px rgb(0, 0, 0);
    animation-direction: alternate;
  }
  
  
  @keyframes move-gradient {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 100% 0%;
    }
  }
  .example-link {
  display: inline-block;
  margin-top: 5px;
  color: #00ccff;
  cursor: pointer;
  font-size: 0.9em;
  text-decoration: underline;
}

.example-link:hover {
  color: #66d9ff;
}
.example-link {
  display: inline-block;
  margin-top: 5px;
  color: #00ccff;
  cursor: pointer;
  font-size: 0.9em;
  text-decoration: underline;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  position: relative;
  max-width: 55%;
  max-height: 80%;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 0 40px rgba(0,0,0,0.6);
  background-color: #111;
  padding: 10px;
}

.modal-content img {
  max-width: 100%;
  max-height: 80vh;
  display: block;
  border-radius: 8px;
}


@media (max-width: 600px) {
  .modal-content {
    width: 90% !important;
    max-width: 90%;
    padding: 10px;
  }

  .modal-content img {
    max-width: 100%;
    height: auto;
  }

  .close-btn {
    font-size: 14px;
    padding: 6px 12px;
    top: 10px;
    right: 10px;
    border-radius: 6px;
  }
}

      </style>
      